// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"Map_mapWrapper__2zMGl"};